import { render, staticRenderFns } from "./ReviewDisabledDialog.vue?vue&type=template&id=292554a2&scoped=true"
import script from "./ReviewDisabledDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDisabledDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewDisabledDialog.vue?vue&type=style&index=0&id=292554a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292554a2",
  null
  
)

export default component.exports